import Vue from 'vue'
import Router from 'vue-router'
import HelloWorld from '@/components/HelloWorld'
import Cast from '@/components/Cast'
import Home from '@/components/Home'
import News from '@/components/News'
import Keyword from '@/components/Keyword'
import Goods from '@/components/Goods'
import Character from '@/components/Character'
import Mechanic from '@/components/Mechanic'
import Story from '@/components/Story'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '*',
      component: Home
    },
    {
    	path: '/cast',
    	component: Cast
    },
    {
  		path: '/home',
  		component: Home
  	},
    {
      path: '/news',
      component: News
    },
    {
      path: '/keyword',
      component: Keyword
    },
    {
      path: '/goods',
      component: Goods
    },
    {
      path: '/character',
      component: Character
    },
    {
      path: '/mechanics',
      component: Mechanic
    },
    {
      path: '/story',
      component: Story
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js